// extracted by mini-css-extract-plugin
export default {"container":"Teeth_container__cUiLx","teeth":"Teeth_teeth__sl+Qk"};